import React from 'react';
import { PageHeader } from '../components/layout/page-header';
import { Wysiwyg } from '../components/wysiwyg';
import { EcdNotFoundPage } from '../models/ecd-page-models';

interface Props {
    pageData: EcdNotFoundPage,
}

function EcdNotFoundPageView(props: Props){
    const { pageData } = props;

    return (
        <>            
            <PageHeader headerText={pageData?.pageTitle} />                               
            <Wysiwyg content={pageData?.mainContent} />            
        </>
    );
}

export default EcdNotFoundPageView;
